import RotateAnimation from "../NativeAnimations/RotateAnimation";

type animationType = "rotate" | undefined;

export function AnimatedIcon({ type, children } : { type: animationType, children: React.ReactNode }) {
  return (
    <>
      {(() => {
        switch (type) {
          case 'rotate':
            return <RotateAnimation>{ children }</RotateAnimation>;
          default:
            return children;
        }
      })()}
    </>
  );
}